import { Deserializable } from '../interfaces';

export class Plans implements Deserializable {
  cantidadServicios: number | null;
  descripcion: string | null;
  idPaquete: number;
  precio: number | null;
  seleccionado: string | null;

  constructor() {
    this.cantidadServicios = null;
    this.descripcion = null;
    this.idPaquete = 0;
    this.precio = null;
    this.seleccionado = null;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
